<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="Markvision Enterprise">
     Markvision Enterprise
    </a>
   </p>
   <p class="toc-1-style">
    <a href="change-history.html#change-history_pt" title="Hist&oacute;rico de altera&ccedil;&otilde;es">
     Hist&oacute;rico de altera&ccedil;&otilde;es
    </a>
   </p>
   <div id="divd0e8">
   </div>
   <p class="toc-1-style">
    <a href="overview-chapter.html#overview-chapter_pt" title="Vis&atilde;o geral">
     Vis&atilde;o geral
    </a>
   </p>
   <div id="divd0e252">
    <p class="toc-2-style">
     <a href="overview-chapter.html#overview-markvision-enterprise_pt" title="No&ccedil;&otilde;es b&aacute;sicas sobre o Markvision Enterprise">
      No&ccedil;&otilde;es b&aacute;sicas sobre o Markvision Enterprise
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="getting-started-chapter.html#getting-started-chapter_pt" title="Primeiros passos">
     Primeiros passos
    </a>
   </p>
   <div id="divd0e281">
    <p class="toc-2-style">
     <a href="best-practices-topic.html#best-practices_pt" title="Pr&aacute;ticas recomendadas">
      Pr&aacute;ticas recomendadas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="system-requirements-topic.html#system-requirements_pt" title="Requisitos de sistema">
      Requisitos de sistema
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-languages-topic.html#supported-languages_pt" title="Idiomas compat&iacute;veis">
      Idiomas compat&iacute;veis
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-printer-models-topic.html#supported-printer-models_pt" title="Modelos de impressora suportados">
      Modelos de impressora suportados
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-database-topic.html#setting-up-database_pt" title="Configura&ccedil;&atilde;o do banco de dados">
      Configura&ccedil;&atilde;o do banco de dados
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-mve-run-as-user-topic.html#d0e1122" title='Configura&ccedil;&atilde;o de usu&aacute;rios "executar como"'>
      Configura&ccedil;&atilde;o de usu&aacute;rios "executar como"
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-markvision-topic.html#installing-markvision_pt" title="Instala&ccedil;&atilde;o do MVE">
      Instala&ccedil;&atilde;o do MVE
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-mve-silently-topic.html#installing-mve-silently_pt" title="Instala&ccedil;&atilde;o silenciosa do MVE">
      Instala&ccedil;&atilde;o silenciosa do MVE
     </a>
    </p>
    <p class="toc-2-style">
     <a href="accessing-mve-topic.html#accessing-mve_pt" title="Acessando o MVE">
      Acessando o MVE
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-language-topic.html#changing-language_pt" title="Alterando o idioma">
      Alterando o idioma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-your-password-topic.html#changing-your-password_pt" title="Alterando a sua senha">
      Alterando a sua senha
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintaining-application-chapter.html#maintaining-application-chapter_pt" title="Manuten&ccedil;&atilde;o do aplicativo">
     Manuten&ccedil;&atilde;o do aplicativo
    </a>
   </p>
   <div id="divd0e1705">
    <p class="toc-2-style">
     <a href="upgrading-to-latest-version-topic.html#upgrading-to-latest-version_pt" title="Atualiza&ccedil;&atilde;o para o MVE 4.2">
      Atualiza&ccedil;&atilde;o para o MVE 4.2
     </a>
    </p>
    <p class="toc-2-style">
     <a href="backing-up-and-restoring-database-topic.html#backing-up-and-restoring-database_pt" title="Backup e restaura&ccedil;&atilde;o do banco de dados">
      Backup e restaura&ccedil;&atilde;o do banco de dados
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-installer-settings-topic.html#changing-installer-settings_pt" title="Atualizando as defini&ccedil;&otilde;es do instalador ap&oacute;s a instala&ccedil;&atilde;o">
      Atualizando as defini&ccedil;&otilde;es do instalador ap&oacute;s a instala&ccedil;&atilde;o
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-user-access-chapter.html#setting-user-access-chapter_pt" title="Configura&ccedil;&atilde;o do acesso do usu&aacute;rio">
     Configura&ccedil;&atilde;o do acesso do usu&aacute;rio
    </a>
   </p>
   <div id="divd0e1977">
    <p class="toc-2-style">
     <a href="setting-up-user-access-overview-topic.html#setting-up-user-access-overview_pt" title="Vis&atilde;o geral">
      Vis&atilde;o geral
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-user-roles-topic.html#understanding-user-roles_pt" title="Compreendendo fun&ccedil;&otilde;es de usu&aacute;rio">
      Compreendendo fun&ccedil;&otilde;es de usu&aacute;rio
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-users-topic.html#managing-users_pt" title="Gerenciamento de usu&aacute;rios">
      Gerenciamento de usu&aacute;rios
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-ldap-server-authentication-topic.html#enabling-ldap-server-authentication_pt" title="Ativa&ccedil;&atilde;o da autentica&ccedil;&atilde;o do servidor LDAP">
      Ativa&ccedil;&atilde;o da autentica&ccedil;&atilde;o do servidor LDAP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-ldap-server-certificates-topic.html#installing-ldap-server-certificates_pt" title="Instalando certificados de servidor LDAP">
      Instalando certificados de servidor LDAP
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="discovering-devices-chapter.html#discovering-devices-chapter_pt" title="Descoberta de impressoras">
     Descoberta de impressoras
    </a>
   </p>
   <div id="divd0e2358">
    <p class="toc-2-style">
     <a href="creating-discovery-profile-topic.html#creating-discovery-profile_pt" title="Cria&ccedil;&atilde;o de perfis de descoberta">
      Cria&ccedil;&atilde;o de perfis de descoberta
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-discovery-profiles-topic.html#managing-discovery-profiles_pt" title="Gerenciando perfis de localiza&ccedil;&atilde;o">
      Gerenciando perfis de localiza&ccedil;&atilde;o
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sample-scenario-discovering-printers-topic.html#sample-scenario-discovering-printers_pt" title="Amostra de cen&aacute;rios: Descoberta de impressoras">
      Amostra de cen&aacute;rios: Descoberta de impressoras
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintaining-dashboard-chapter.html#maintaining-dashboard-chapter_pt" title="Gerenciamento do painel de seguran&ccedil;a">
     Gerenciamento do painel de seguran&ccedil;a
    </a>
   </p>
   <div id="divd0e2614">
    <p class="toc-2-style">
     <a href="overview-security-dashboard-topic.html#overview-security-dashboard_pt" title="Vis&atilde;o geral">
      Vis&atilde;o geral
     </a>
    </p>
    <p class="toc-2-style">
     <a href="accessing-dashboard-topic.html#accessing-dashboard_pt" title="Acessar o painel de seguran&ccedil;a">
      Acessar o painel de seguran&ccedil;a
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-device-security-information-topic.html#managing-device-security-information_pt" title="Gerenciamento de Informa&ccedil;&otilde;es de seguran&ccedil;a do dispositivo">
      Gerenciamento de Informa&ccedil;&otilde;es de seguran&ccedil;a do dispositivo
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-device-conformance-check-topic.html#managing-device-conformance-check_pt" title="Gerenciamento da Verifica&ccedil;&atilde;o de conformidade do dispositivo">
      Gerenciamento da Verifica&ccedil;&atilde;o de conformidade do dispositivo
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="finding-devices-chapter.html#finding-devices-chapter_pt" title="Exibi&ccedil;&atilde;o de impressoras">
     Exibi&ccedil;&atilde;o de impressoras
    </a>
   </p>
   <div id="divd0e2702">
    <p class="toc-2-style">
     <a href="viewing-printer-list-topic.html#viewing-printer-list_pt" title="Visualiza&ccedil;&atilde;o da lista de impressoras">
      Visualiza&ccedil;&atilde;o da lista de impressoras
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-device-information-topic.html#viewing-device-information_pt" title="Visualizando as informa&ccedil;&otilde;es da impressora">
      Visualizando as informa&ccedil;&otilde;es da impressora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="exporting-data-topic.html#exporting-data_pt" title="Exportando dados da impressora">
      Exportando dados da impressora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-views-topic.html#managing-views_pt" title="Gerenciamento de exibi&ccedil;&otilde;es">
      Gerenciamento de exibi&ccedil;&otilde;es
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-printer-listing-view-topic.html#changing-printer-listing-view_pt" title="Alterando a exibi&ccedil;&atilde;o de lista de impressoras">
      Alterando a exibi&ccedil;&atilde;o de lista de impressoras
     </a>
    </p>
    <p class="toc-2-style">
     <a href="filtering-printers-using-search-bar-topic.html#filtering-printers-using-search-bar_pt" title="filtrando impressoras usando a barra de pesquisa">
      filtrando impressoras usando a barra de pesquisa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-keywords-topic.html#managing-keywords_pt" title="Gerenciamento de palavras-chave">
      Gerenciamento de palavras-chave
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-device-life-cycle-states-topic.html#d0e3162" title="Uso das pesquisas salvas">
      Uso das pesquisas salvas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sample-scenario-monitor-fleet-topic.html#sample-scenario-monitor-fleet_pt" title="Amostra de cen&aacute;rios: Monitoramento dos n&iacute;veis de toner de sua frota">
      Amostra de cen&aacute;rios: Monitoramento dos n&iacute;veis de toner de sua frota
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-devices-chapter.html#securing-devices-chapter_pt" title="Prote&ccedil;&atilde;o das comunica&ccedil;&otilde;es da impressora">
     Prote&ccedil;&atilde;o das comunica&ccedil;&otilde;es da impressora
    </a>
   </p>
   <div id="divd0e4099">
    <p class="toc-2-style">
     <a href="understanding-security-status-topic.html#understanding-security-status_pt" title="No&ccedil;&otilde;es b&aacute;sicas sobre os estados de seguran&ccedil;a da impressora">
      No&ccedil;&otilde;es b&aacute;sicas sobre os estados de seguran&ccedil;a da impressora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="securing-printers-using-default-config-topic.html#securing-printers-using-default-config_pt" title="Prote&ccedil;&atilde;o das impressoras usando as configura&ccedil;&otilde;es padr&atilde;o">
      Prote&ccedil;&atilde;o das impressoras usando as configura&ccedil;&otilde;es padr&atilde;o
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-fac-permissions-topic.html#understanding-fac-permissions_pt" title="Compreens&atilde;o dos controles de acesso a fun&ccedil;&otilde;es e permiss&otilde;es">
      Compreens&atilde;o dos controles de acesso a fun&ccedil;&otilde;es e permiss&otilde;es
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-device-security-topic.html#configuring-device-security_pt" title="Configurando a seguran&ccedil;a da impressora">
      Configurando a seguran&ccedil;a da impressora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="securing-printer-communications-on-your-fleet-topic.html#securing-printer-communications-on-your-fleet_pt" title="Prote&ccedil;&atilde;o das comunica&ccedil;&otilde;es da impressora no parque de impress&atilde;o">
      Prote&ccedil;&atilde;o das comunica&ccedil;&otilde;es da impressora no parque de impress&atilde;o
     </a>
    </p>
    <p class="toc-2-style">
     <a href="securing-printers-topic.html#securing-printers_pt" title="Outras maneiras de proteger suas impressoras">
      Outras maneiras de proteger suas impressoras
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="managing-assets-chapter.html#managing-assets-chapter_pt" title="Gerenciamento de impressoras">
     Gerenciamento de impressoras
    </a>
   </p>
   <div id="divd0e4463">
    <p class="toc-2-style">
     <a href="restarting-printer-topic.html#restarting-printer_pt" title="Reiniciando a impressora">
      Reiniciando a impressora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-ews-topic.html#viewing-ews_pt" title="Exibindo o Embedded Web Server da impressora">
      Exibindo o Embedded Web Server da impressora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="auditing-devices-topic.html#auditing-devices_pt" title="Auditando impressoras">
      Auditando impressoras
     </a>
    </p>
    <p class="toc-2-style">
     <a href="updating-printer-status-topic.html#updating-printer-status_pt" title="Atualiza&ccedil;&atilde;o do status da impressora">
      Atualiza&ccedil;&atilde;o do status da impressora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-device-state-topic.html#setting-device-state_pt" title="Configurando o estado da impressora">
      Configurando o estado da impressora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="assigning-configurations-to-devices-topic.html#assigning-configurations-to-devices_pt" title="Como atribuir configura&ccedil;&otilde;es a impressoras">
      Como atribuir configura&ccedil;&otilde;es a impressoras
     </a>
    </p>
    <p class="toc-2-style">
     <a href="unassigning-configurations-topic.html#unassigning-configurations_pt" title="Cancelando atribui&ccedil;&otilde;es de configura&ccedil;&otilde;es">
      Cancelando atribui&ccedil;&otilde;es de configura&ccedil;&otilde;es
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enforcing-configurations-topic.html#enforcing-configurations_pt" title="Aplicando configura&ccedil;&otilde;es">
      Aplicando configura&ccedil;&otilde;es
     </a>
    </p>
    <p class="toc-2-style">
     <a href="checking-device-conformance-topic.html#checking-device-conformance_pt" title="Verificando a conformidade da impressora com uma configura&ccedil;&atilde;o">
      Verificando a conformidade da impressora com uma configura&ccedil;&atilde;o
     </a>
    </p>
    <p class="toc-2-style">
     <a href="deploying-files-to-printers-topic.html#deploying-files-to-printers_pt" title="Implantando arquivos em impressoras">
      Implantando arquivos em impressoras
     </a>
    </p>
    <p class="toc-2-style">
     <a href="updating-printer-firmware-topic.html#updating-printer-firmware_pt" title="Atualizando o firmware da impressora">
      Atualizando o firmware da impressora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="uninstalling-applications-from-devices-topic.html#uninstalling-applications-from-devices_pt" title="Desinstala&ccedil;&atilde;o de aplicativos das impressoras">
      Desinstala&ccedil;&atilde;o de aplicativos das impressoras
     </a>
    </p>
    <p class="toc-2-style">
     <a href="assigning-events-to-device-topic.html#assigning-events-to-device_pt" title="Atribuindo eventos a impressoras">
      Atribuindo eventos a impressoras
     </a>
    </p>
    <p class="toc-2-style">
     <a href="assigning-keyword-topic.html#assigning-keyword_pt" title="Atribuindo palavras-chave a impressoras">
      Atribuindo palavras-chave a impressoras
     </a>
    </p>
    <p class="toc-2-style">
     <a href="entering-credentials-secured-printers-topic.html#entering-credentials-secured-printers_pt" title="Inserindo credenciais em impressoras protegidas">
      Inserindo credenciais em impressoras protegidas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-printer-certificates-manually-topic.html#configuring-printer-certificates-manually_pt" title="Configura&ccedil;&atilde;o manual dos certificados da impressora padr&atilde;o">
      Configura&ccedil;&atilde;o manual dos certificados da impressora padr&atilde;o
     </a>
    </p>
    <p class="toc-2-style">
     <a href="removing-printers-topic.html#removing-printers_pt" title="Remo&ccedil;&atilde;o de impressoras">
      Remo&ccedil;&atilde;o de impressoras
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="managing-configurations-chapter.html#managing-configurations-chapter_pt" title="Gerenciamento de configura&ccedil;&otilde;es">
     Gerenciamento de configura&ccedil;&otilde;es
    </a>
   </p>
   <div id="divd0e5069">
    <p class="toc-2-style">
     <a href="managing-configurations-overview-topic.html#managing-configurations-overview_pt" title="Vis&atilde;o geral">
      Vis&atilde;o geral
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-configuration-topic.html#creating-configuration_pt" title="Cria&ccedil;&atilde;o de configura&ccedil;&otilde;es">
      Cria&ccedil;&atilde;o de configura&ccedil;&otilde;es
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-configuration-from-printer-topic.html#creating-configuration-from-printer_pt" title="Criando uma configura&ccedil;&atilde;o a partir de uma impressora">
      Criando uma configura&ccedil;&atilde;o a partir de uma impressora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sample-scenario-cloning-configurations-topic.html#sample-scenario-cloning-configurations_pt" title="Amostra de cen&aacute;rios: Clonagem de uma configura&ccedil;&atilde;o">
      Amostra de cen&aacute;rios: Clonagem de uma configura&ccedil;&atilde;o
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-advanced-security-component-topic.html#creating-advanced-security-component_pt" title="Cria&ccedil;&atilde;o de um componente de seguran&ccedil;a avan&ccedil;ada a partir de uma impressora">
      Cria&ccedil;&atilde;o de um componente de seguran&ccedil;a avan&ccedil;ada a partir de uma impressora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="generating-printable-version-topic.html#generating-printable-version_pt" title="Gera&ccedil;&atilde;o de uma vers&atilde;o para impress&atilde;o das defini&ccedil;&otilde;es de configura&ccedil;&atilde;o">
      Gera&ccedil;&atilde;o de uma vers&atilde;o para impress&atilde;o das defini&ccedil;&otilde;es de configura&ccedil;&atilde;o
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-dynamic-settings-topic.html#understanding-dynamic-settings_pt" title="No&ccedil;&otilde;es b&aacute;sicas sobre configura&ccedil;&otilde;es din&acirc;micas">
      No&ccedil;&otilde;es b&aacute;sicas sobre configura&ccedil;&otilde;es din&acirc;micas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-variable-settings-topic.html#understanding-variable-settings_pt" title="Aprendendo sobre defini&ccedil;&otilde;es de vari&aacute;vel">
      Aprendendo sobre defini&ccedil;&otilde;es de vari&aacute;vel
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-color-permissions-topic.html#configuring-color-permissions_pt" title="Configurando as permiss&otilde;es de impress&atilde;o colorida">
      Configurando as permiss&otilde;es de impress&atilde;o colorida
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-applications-package-topic.html#creating-applications-package_pt" title="Criando um pacote de aplicativos">
      Criando um pacote de aplicativos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="importing-exporting-configuration-file-topic.html#importing-exporting-configuration-file_pt" title="Importando ou exportando uma configura&ccedil;&atilde;o">
      Importando ou exportando uma configura&ccedil;&atilde;o
     </a>
    </p>
    <p class="toc-2-style">
     <a href="importing-files-to-resource-library-topic.html#importing-files-to-resource-library_pt" title="Importa&ccedil;&atilde;o de arquivos para a biblioteca de recursos">
      Importa&ccedil;&atilde;o de arquivos para a biblioteca de recursos
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-cert-auto-manage-chapter.html#setting-up-cert-auto-manage-chapter_pt" title="Gerenciamento de certificados">
     Gerenciamento de certificados
    </a>
   </p>
   <div id="divd0e5593">
    <p class="toc-2-style">
     <a href="setting-up-MVE-manage-certificates-automatically-group.html#d0e5596" title="Configura&ccedil;&atilde;o do MVE para o gerenciamento autom&aacute;tico de certificados">
      Configura&ccedil;&atilde;o do MVE para o gerenciamento autom&aacute;tico de certificados
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-certificates-using-SCEP-group.html#d0e5922" title="Gerenciamento de certificados usando a autoridade de certifica&ccedil;&otilde;es da Microsoft pelo SCEP">
      Gerenciamento de certificados usando a autoridade de certifica&ccedil;&otilde;es da Microsoft pelo SCEP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-certificates-using-MSCEWS-group.html#d0e6644" title="Gerenciando certificados usando a autoridade de certifica&ccedil;&otilde;es da Microsoft pelo MSCEWS">
      Gerenciando certificados usando a autoridade de certifica&ccedil;&otilde;es da Microsoft pelo MSCEWS
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-certificates-using-OpenXPKI-CA-group.html#d0e7629" title="Gerenciamento de certificados usando a autoridade de certifica&ccedil;&otilde;es da OpenXPKI pelo SCEP">
      Gerenciamento de certificados usando a autoridade de certifica&ccedil;&otilde;es da OpenXPKI pelo SCEP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-certificates-using-EST-group.html#d0e8696" title="Gerenciamento de certificados usando a autoridade de certifica&ccedil;&otilde;es da OpenXPKI pelo EST">
      Gerenciamento de certificados usando a autoridade de certifica&ccedil;&otilde;es da OpenXPKI pelo EST
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="managing-device-alerts-chapter.html#managing-device-alerts-chapter_pt" title="Gerenciamento de alertas da impressora">
     Gerenciamento de alertas da impressora
    </a>
   </p>
   <div id="divd0e9781">
    <p class="toc-2-style">
     <a href="managing-printer-alerts-overview-topic.html#managing-printer-alerts-overview_pt" title="Vis&atilde;o geral">
      Vis&atilde;o geral
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-action-topic.html#creating-action_pt" title="Como criar uma a&ccedil;&atilde;o">
      Como criar uma a&ccedil;&atilde;o
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-action-placeholders-topic.html#understanding-action-placeholders_pt" title="Compreendendo espa&ccedil;os reservados de a&ccedil;&atilde;o">
      Compreendendo espa&ccedil;os reservados de a&ccedil;&atilde;o
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-actions-topic.html#managing-actions_pt" title="Gerenciamento de a&ccedil;&otilde;es">
      Gerenciamento de a&ccedil;&otilde;es
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-event-topic.html#creating-event_pt" title="Cria&ccedil;&atilde;o de um evento">
      Cria&ccedil;&atilde;o de um evento
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-printer-alerts-topic.html#understanding-printer-alerts_pt" title="Compreendendo alertas da impressora">
      Compreendendo alertas da impressora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-events-topic.html#managing-events_pt" title="Gerenciando eventos">
      Gerenciando eventos
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="viewing-tasks-chapter.html#viewing-tasks-chapter_pt" title="Exibi&ccedil;&atilde;o do status e do hist&oacute;rico das tarefas">
     Exibi&ccedil;&atilde;o do status e do hist&oacute;rico das tarefas
    </a>
   </p>
   <div id="divd0e10413">
    <p class="toc-2-style">
     <a href="viewing-task-status-history-overview-topic.html#viewing-task-status-history-overview_pt" title="Vis&atilde;o geral">
      Vis&atilde;o geral
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-task-status-topic.html#viewing-task-status_pt" title="Visualizando o status da tarefa">
      Visualizando o status da tarefa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="stopping-tasks-topic.html#stopping-tasks_pt" title="Interrup&ccedil;&atilde;o de tarefas">
      Interrup&ccedil;&atilde;o de tarefas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-logs-topic.html#viewing-logs_pt" title="Exibindo registros">
      Exibindo registros
     </a>
    </p>
    <p class="toc-2-style">
     <a href="clearing-logs-topic.html#clearing-logs_pt" title="Limpando registros">
      Limpando registros
     </a>
    </p>
    <p class="toc-2-style">
     <a href="exporting-logs-topic.html#exporting-logs_pt" title="Exportando registros">
      Exportando registros
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="scheduling-tasks.html#scheduling-tasks_pt" title="Programa&ccedil;&atilde;o de tarefas">
     Programa&ccedil;&atilde;o de tarefas
    </a>
   </p>
   <div id="divd0e10521">
    <p class="toc-2-style">
     <a href="creating-schedule-topic.html#creating-schedule_pt" title="Como criar uma programa&ccedil;&atilde;o">
      Como criar uma programa&ccedil;&atilde;o
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-schedules-topic.html#managing-schedules_pt" title="Gerenciando tarefas programadas">
      Gerenciando tarefas programadas
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="admin-tasks-chapter.html#admin-tasks-chapter_pt" title="Execu&ccedil;&atilde;o de outras tarefas administrativas">
     Execu&ccedil;&atilde;o de outras tarefas administrativas
    </a>
   </p>
   <div id="divd0e10663">
    <p class="toc-2-style">
     <a href="configuring-system-settings-topic.html#configuring-system-settings_pt" title="Configurando as defini&ccedil;&otilde;es gerais">
      Configurando as defini&ccedil;&otilde;es gerais
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-email-settings-topic.html#configuring-email-settings_pt" title="Defini&ccedil;&atilde;o das configura&ccedil;&otilde;es de e-mail">
      Defini&ccedil;&atilde;o das configura&ccedil;&otilde;es de e-mail
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adding-login-disclaimer-topic.html#adding-login-disclaimer_pt" title="Adi&ccedil;&atilde;o de isen&ccedil;&atilde;o de responsabilidade no login">
      Adi&ccedil;&atilde;o de isen&ccedil;&atilde;o de responsabilidade no login
     </a>
    </p>
    <p class="toc-2-style">
     <a href="signing-mve-certificate-topic.html#signing-mve-certificate_pt" title="Assinatura do certificado do MVE">
      Assinatura do certificado do MVE
     </a>
    </p>
    <p class="toc-2-style">
     <a href="removing-user-information-topic.html#removing-user-information_pt" title="Removendo informa&ccedil;&otilde;es e refer&ecirc;ncias de usu&aacute;rio">
      Removendo informa&ccedil;&otilde;es e refer&ecirc;ncias de usu&aacute;rio
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="faq-chapter.html#faq-chapter_pt" title="Perguntas frequentes">
     Perguntas frequentes
    </a>
   </p>
   <div id="divd0e10908">
    <p class="toc-2-style">
     <a href="faq-chapter.html#frequently-asked-questions_pt" title="Perguntas frequentes do Markvision Enterprise">
      Perguntas frequentes do Markvision Enterprise
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_pt" title="Solu&ccedil;&atilde;o de problemas">
     Solu&ccedil;&atilde;o de problemas
    </a>
   </p>
   <div id="divd0e11102">
    <p class="toc-2-style">
     <a href="trb-forgotten-password-mve-topic.html#trb-forgotten-password-mve_pt" title="O usu&aacute;rio esqueceu a senha">
      O usu&aacute;rio esqueceu a senha
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-admin-forgotten-password-mve-topic.html#trb-admin-forgotten-password-mve_pt" title="O usu&aacute;rio Administrador esqueceu a senha">
      O usu&aacute;rio Administrador esqueceu a senha
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-page-loading-infinitely-topic.html#trb-page-loading-infinitely_pt" title="A p&aacute;gina n&atilde;o carrega">
      A p&aacute;gina n&atilde;o carrega
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-discover-network-device-topic.html#trb-cannot-discover-network-device_pt" title="N&atilde;o &eacute; poss&iacute;vel detectar uma impressora de rede">
      N&atilde;o &eacute; poss&iacute;vel detectar uma impressora de rede
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-incorrect-device-information-topic.html#trb-incorrect-device-information_pt" title="Informa&ccedil;&otilde;es incorretas de impressora">
      Informa&ccedil;&otilde;es incorretas de impressora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-mve-does-not-recognize-secured-printer-topic.html#trb-mve-does-not-recognize-secured-printer_pt" title="O MVE n&atilde;o reconhece uma impressora como segura">
      O MVE n&atilde;o reconhece uma impressora como segura
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-config-enforcement-fails-topic.html#trb-config-enforcement-fails_pt" title="A aplica&ccedil;&atilde;o de configura&ccedil;&otilde;es com v&aacute;rios aplicativos falha na primeira tentativa, mas &eacute; bem-sucedida nas tentativas seguintes">
      A aplica&ccedil;&atilde;o de configura&ccedil;&otilde;es com v&aacute;rios aplicativos falha na primeira tentativa, mas &eacute; bem-sucedida nas tentativas seguintes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-enforcement-printer-cert-fails-topic.html#trb-enforcement-printer-cert-fails_pt" title="Falha na aplica&ccedil;&atilde;o de configura&ccedil;&otilde;es com certificado da impressora">
      Falha na aplica&ccedil;&atilde;o de configura&ccedil;&otilde;es com certificado da impressora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-openxpki-ca-group.html#d0e11321" title="Autoridade de certifica&ccedil;&otilde;es OpenXPKI">
      Autoridade de certifica&ccedil;&otilde;es OpenXPKI
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="appendix-chapter.html#appendix-chapter_pt" title="Ap&ecirc;ndice">
     Ap&ecirc;ndice
    </a>
   </p>
   <div id="divd0e11491">
    <p class="toc-2-style">
     <a href="understanding-ports-and-protocols-topic.html#understanding-ports-and-protocols_pt" title="Portas e protocolos">
      Portas e protocolos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-automatic-approval-certificate-requests-microsoft-ca-topic.html#enabling-automatic-approval-certificate-requests-microsoft-ca_pt" title="Ativa&ccedil;&atilde;o da aprova&ccedil;&atilde;o autom&aacute;tica de solicita&ccedil;&otilde;es de certificado no Microsoft CA">
      Ativa&ccedil;&atilde;o da aprova&ccedil;&atilde;o autom&aacute;tica de solicita&ccedil;&otilde;es de certificado no Microsoft CA
     </a>
    </p>
    <p class="toc-2-style">
     <a href="revoking-certificates-topic.html#revoking-certificates_pt" title="Revoga&ccedil;&atilde;o de certificados">
      Revoga&ccedil;&atilde;o de certificados
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="leap_notices.html#leap_notices_pt" title="Avisos">
     Avisos
    </a>
   </p>
   <div id="divd0e11867">
    <p class="toc-2-style">
     <a href="leap_notices.html#d0e11870" title="Aviso de edi&ccedil;&atilde;o">
      Aviso de edi&ccedil;&atilde;o
     </a>
    </p>
    <p class="toc-2-style">
     <a href="leap_notices.html#d0e11906" title="Marcas comerciais">
      Marcas comerciais
     </a>
    </p>
    <p class="toc-2-style">
     <a href="leap_notices.html#us-government-rights_pt" title="GOVERNMENT END USERS">
      GOVERNMENT END USERS
     </a>
    </p>
    <p class="toc-2-style">
     <a href="leap_notices.html#jmdns-license_pt" title="JmDNS License">
      JmDNS License
     </a>
    </p>
    <p class="toc-2-style">
     <a href="leap_notices.html#licensing-notices-program-folder_pt" title="Avisos de licen&ccedil;a">
      Avisos de licen&ccedil;a
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="glossary.html#glossary_pt" title="Gloss&aacute;rio">
     Gloss&aacute;rio
    </a>
   </p>
   <div id="divd0e11936">
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue